<template>
  <section style="background: #FFFFFF;padding: 10px">
    <div class="appeal-info">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为进一步优化营商环境，畅通企业诉求表达渠道，协调解决企业全生命周期中各种困难和问题，助力全省中小企业高质量发展，省工业和信息化厅（青海省加快非公有制经济发展工作领导小组办公室）决定建立青海省中小微企业诉求意见登记平台（试运行），以青海省中小企业公共服务平台、青海省中小企业公共服务微信公众号和青海省中小企业服务热线电话0971-96868三种方式登记中小微企业诉求意见，做到“有问必答，有求必应，有忧必解”。
    </div>
    <div class="appeal-info">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中小微企业可通过诉求意见登记平台，反映企业在生产经营中面临的各类问题，并能对政府相关部门在政策制定、政策执行、政策服务等方面提出意见建议。青海省工业和信息化厅（青海省加快非公有制经济发展工作领导小组办公室）将充分发挥跨部门协调联动工作机制，跟踪落实企业诉求办理进度，着力解决中小微企业在发展存在的难点、痛点、堵点等突出问题，切实维护广大中小微企业的合法权益，培育我省经济增长新动能。
    </div>
    <div class="fill-hint">
      * 提示：请您如实填写，带*号的为必填项，我们将对涉及您的个人信息保密。
    </div>
    <el-form label-position="right" :rules="appealInfoRules" ref="appealInfoformRef" :model="appealInfo" label-width="170px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业名称：" prop="enterpriseName">
            <el-input v-model="appealInfo.enterpriseName" maxlength="250"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
            <el-input v-model="appealInfo.enterpriseCode" maxlength="18"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业所在地：" prop="park">
            <el-row style="width: 100%">
              <el-col :span="12">
                <el-cascader clearable
                             ref="cascader"
                             v-model="appealInfo.locateArea"
                             :props="{ expandTrigger: 'hover',checkStrictly: true,emitPath:false }"
                             :options="locateAreaOptions"
                             @change="handleLocateAreaChange"
                             placeholder="请选择地区" style="width:100%">
                </el-cascader>
              </el-col>
              <el-col :span="12">
                <el-select
                  clearable
                  style="width: 100%"
                  v-model="appealInfo.park"
                  filterable
                  placeholder="请选择园区">
                  <el-option
                    v-for="item in parkList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select></el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址：" prop="detailAddress">
            <el-input v-model="appealInfo.detailAddress"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="法定代表人：" prop="legalPerson">
            <el-input maxlength="50" v-model="appealInfo.legalPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法定代表身份证号码：" prop="legalPersonId">
            <el-input maxlength="50" v-model="appealInfo.legalPersonId"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="法人联系电话：" prop="legalPersonPhone">
            <el-input maxlength="50" v-model="appealInfo.legalPersonPhone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业联系人：" prop="contactPerson">
            <el-input maxlength="50" v-model="appealInfo.contactPerson"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人身份证号：" prop="contactIdCard">
            <el-input maxlength="50" v-model="appealInfo.contactIdCard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="contact">
            <el-input maxlength="50" v-model="appealInfo.contact"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="诉求主要涉及单位：" prop="appealRelatedOrg">
            <el-input maxlength="50" v-model="appealInfo.appealRelatedOrg"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="诉求类型：" prop="appealType">
            <el-select filterable v-model="appealInfo.appealType" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in appealTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="诉求事项说明：" prop="appealContent">
            <el-input v-model="appealInfo.appealContent" type="textarea" :rows="6" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="上传附件">
            <el-upload
              class="upload-demo"
              action="/appeal/file/upload/appealAttachment"
              :on-success="handleAttachmentSuccess"
              :on-remove="handleRemove"
              multiple
              :file-list="fileList">
              <el-button icon="el-icon-upload" type="main">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="width: 100%;text-align: center;margin-top: 10px;">
      <el-button type="main" style="width: 150px;" round @click="handleAppealSubmit">提 交</el-button>
    </div>
  </section>
</template>
<script>
  import { portalEnterpriseAppeal, portalDictionary, portalOrganizationList, portalParkList, portalUserInfo,portalAppealInfo,portalAppealInfoEdit,portalAreaTree} from '@/api/restapi.js'
  export default {
    data () {
      var validatePark = (rule, value, callback) => {
        if (!this.appealInfo.locateArea && !this.appealInfo.park) {
          callback(new Error("请至少选择一项"))
        } else {
          //任意值被填写，清除验证提示
          if (!this.appealInfo.locateArea || !this.appealInfo.park) {
            this.$refs.appealInfoformRef.clearValidate()
          }
          callback()
        }
      }
      return {
        fileList: [],
        appealInfo: {
          attachments: []
        },
        userInfo: {},
        appealTypeList: [],
        appealPayTypeList: [],
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        enterpriseIndustryList: [],
        antiEnterpriseTypeList: [],
        organizationList: [],
        locateAreaOptions: [],
        parkList: [],
        appealInfoRules: {
          enterpriseName: [
            { required: true, message: '请填写企业名称', trigger: 'blur' }
          ],
          enterpriseCode: [
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18,message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { pattern:/^[A-Za-z0-9]+$/, message: '只能输入数字、字母', trigger: 'blur'}
          ],
          legalPerson: [
            { required: true, message: '请填写法定代表人', trigger: 'blur' }
          ],
          legalPersonId: [
            { required: true, message: '请填写法定代表身份证号码', trigger: 'blur' }
          ],
          legalPersonPhone: [
            { required: true, message: '请填写法定代表联系电话', trigger: 'blur' }
          ],
          contactPerson: [
            { required: true, message: '请填写企业联系人', trigger: 'blur' }
          ],
          contact: [
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          contactIdCard: [
            { required: true, message: '请填写联系人身份证号', trigger: 'blur' }
          ],
          park: [
            { required: true, validator: validatePark, trigger: 'change' }
          ],
          appealType: [
            { required: true, message: '请填写诉求类型', trigger: 'blur' }
          ],
          appealRelatedOrg: [
            { required: true, message: '请填写诉求主要涉及单位', trigger: 'blur' }
          ],
          appealContent: [
            { required: true, message: '请填写诉求事项说明', trigger: 'blur' }
          ],
          detailAddress: [
            { required: true, message: '请填写详细地址', trigger: 'blur' }
          ]
        },
        appealType: 'appealInfo'
      }
    },
    mounted () {
      portalUserInfo().then(res => {
        if (res.data.code !== 0) {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }else {
          this.userInfo = res.data.data
          if (!(this.userInfo.organization&&this.userInfo.organizationCode
            &&this.userInfo.legalPerson&&this.userInfo.legalPersonPhone
            &&this.userInfo.name&&this.userInfo.phone
            &&this.userInfo.email&&this.userInfo.employee
            &&this.userInfo.enterpriseSize&&this.userInfo.enterpriseType
            &&this.userInfo.registerMoney&&this.userInfo.registerTime
            &&this.userInfo.registerAddress&&this.userInfo.registerDetailAddress
            &&this.userInfo.locationArea&&this.userInfo.address
            &&this.userInfo.licenseUrl&&this.userInfo.commitmentUrl)) {
              this.$parent.handleDropDwonCommand('my_company')
              this.$parent.showErrorMsg('请完善企业信息')
          }
        }
      })
      portalDictionary('appeal_type').then(res => {
        if (res.data.code === 0) {
          this.appealTypeList = res.data.data
        }
      })
      portalDictionary('appeal_pay_type').then(res => {
        if (res.data.code === 0) {
          this.appealPayTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_industry').then(res => {
        if (res.data.code === 0) {
          this.enterpriseIndustryList = res.data.data
        }
      })
      portalDictionary('anti_enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.antiEnterpriseTypeList = res.data.data
        }
      })
      portalAreaTree().then(res => {
        if (res.data.code === 0){
          this.locateAreaOptions = res.data.data
        }
      })
      this.queryParkAsync('')
      portalOrganizationList('').then(res => {
        if (res.data.code === 0) {
          res.data.data.list.forEach(o => {
            this.organizationList.push({
              name: o.name,
              id: o.id
            })
          })
          if (this.$route.query.id) {
            portalAppealInfo(this.$route.query.id).then(res => {
              if (res.data.code === 0){
                this.appealInfo = res.data.data
                if (this.appealInfo.infoType==='pay') {
                  this.appealType = 'payInfo'
                }
                if (this.appealInfo.attachments) {
                  this.appealInfo.attachments.forEach(file => {
                    this.fileList.push({
                      name: file.fileName,
                      response: {
                        data: file.fileUrl
                      }
                    })
                  })
                }
              }
            })
          }else {
            this.initEmptyAppealInfo()
          }
        }
      })
    },
    methods: {
      updateUserInfo (newInfo) {
        console.log('update new info')
        console.log(newInfo)
        this.userInfo = Object.assign({},newInfo)
      },
      handleLocateAreaChange (value) {
        portalParkList('',value).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
            this.appealInfo.park = ''
          }
        })
        this.$refs.cascader.toggleDropDownVisible(false);
      },
      initEmptyAppealInfo () {
        this.appealInfo = Object.assign({attachments:[]},{
          enterpriseName: this.userInfo.organization,
          enterpriseCode: this.userInfo.organizationCode,
          park: this.userInfo.locationArea?parseInt(this.userInfo.locationArea):undefined,
          legalPerson: this.userInfo.legalPerson,
          legalPersonPhone: this.userInfo.legalPersonPhone,
          contactPerson: this.userInfo.name,
          enterpriseSize: this.userInfo.enterpriseSize,
          contact: this.userInfo.phone,
          detailAddress: this.userInfo.address
        })
      },
      handleAttachmentSuccess (res, file) {
        this.appealInfo.attachments.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.appealInfo.attachments = att
      },
      valForm (formRef) {
        let isValid = true
        this.$refs[formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
        }
        return isValid
      },
      queryOrgAsync (queryString, cb) {
        portalOrganizationList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            cb(names)
          }
        })
      },
      handleOrgSelect (item) {
        this.appealInfo.appealOrganization = item.id
      },
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      handleParkSelect (item) {
        this.appealInfo.park = item.id
      },
      handleAppealSubmit() {
        if (!(this.userInfo.organization&&this.userInfo.organizationCode
          &&this.userInfo.legalPerson&&this.userInfo.legalPersonPhone
          &&this.userInfo.name&&this.userInfo.phone
          &&this.userInfo.email&&this.userInfo.employee
          &&this.userInfo.enterpriseSize&&this.userInfo.enterpriseType
          &&this.userInfo.registerMoney&&this.userInfo.registerTime
          &&this.userInfo.registerAddress&&this.userInfo.registerDetailAddress
          &&this.userInfo.locationArea&&this.userInfo.address
          &&this.userInfo.licenseUrl&&this.userInfo.commitmentUrl)) {
            this.$parent.handleDropDwonCommand('my_company')
            this.$parent.showErrorMsg('请完善企业信息')
            return
        }
        let val = this.valForm('appealInfoformRef')
        if (!val) {
          return
        }
        if (this.appealInfo.id) {
          portalAppealInfoEdit(this.appealInfo).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.$router.push('/portal/appealProgress')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        }else {
          portalEnterpriseAppeal(this.appealInfo).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$router.push('/portal/appealProgress')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        }
      }
    }
  }
</script>
<style>
  .el-tabs {
    background: #FFFFFF;
    padding: 10px;
  }
  .el-tabs__active-bar {
    background-color: #aa051a;
    height: 4px;
  }
  .el-tabs__item {
    font-size: 15px;
  }
  .el-tabs__item.is-active {
    color: #07438A;
  }
  .appeal-info {
    font-size: 13px;
  }
  .el-cascader-panel .el-radio{
    z-index: 10;
    width: 99%;
    height: 99%;
    position: absolute;
    top: 10px;
    right: -12px;
  }
  .el-cascader-panel .el-radio__input{
    visibility: hidden;
  }
  .el-cascader-panel .el-cascader-node__postfix{
    top: 10px;
  }
  .fill-hint {
    font-size: 10px;
    color: #FF0000;
    margin: 10px 0;
  }
  .payInfoTag {
    color: #0068BC;
    border: 1px solid #0068BC;
    font-size: 15px;
    margin-left: 50px;
    border-radius: 5px;
    background: #f4fbfe;
    padding: 3px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/PortalEnterpriseAppeal.vue